import { Button } from "@gisce/oficina-virtual-components";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const CrmButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Button
      color="primary"
      variant="contained"
      onClick={() => navigate(t('common:url.contact') + '?category=billing')}
    >
      {t('common:text.help_dialog_contact_button')}
    </Button>
  );
};

export default CrmButton;
